import compose, { composeSync } from './compose';
export { compose, composeSync };
/**
 * 判断是否为异步函数、普通函数
 * @param func
 * @returns
 */
const isFunction = func => ["[object AsyncFunction]", "[object Function]"].includes(Object.prototype.toString.call(func));
export default class Middleware {
    constructor() {
        this.middlewares = [];
    }
    /**
     * 注册中间件
     * @param middleware
     * @returns Middleware
     */
    use(middleware) {
        const { middlewares } = this;
        if (!Array.isArray(middleware)) {
            middleware = [middleware];
        }
        middleware.forEach(function (m) {
            if (!isFunction(m)) {
                return;
            }
            middlewares.push(m);
        });
        return this;
    }
    ;
    /**
     * 触发中间件
     * @param ctx
     * @returns Promise<any>
     */
    dispatch(ctx) {
        const { middlewares } = this;
        return compose(middlewares)(ctx);
    }
    /**
     * 同步触发中间件
     * @param ctx
     * @returns Promise<any>
     */
    dispatchSync(ctx) {
        const { middlewares } = this;
        return composeSync(middlewares)(ctx);
    }
}
